module.exports = __webpack_public_path__ + "img/pepsico-logo.4774065b.svg";